/* ============================================================
   Christopher — THRIVE website concierge widget (Shopify asset)
   Self-contained. Gated behind ?christopher=1 so it ONLY runs in
   test mode and never affects normal visitors / RepAI.
   Design copied from RepAI/Voiceflow's real style.css values.
   Features: chat (streaming) · proactive icon nudge · slide-out menu
   (New Conversation, quick actions, Recent, View cart, Checkout) ·
   expand/fullscreen toggle.
   ============================================================ */
(function () {
  try {
    if (/[?&]christopher=0/i.test(location.search)) return;        // LIVE for all visitors (2026-06-21); append ?christopher=0 to force-disable for debugging
    if (window.__christopherLoaded) return; window.__christopherLoaded = true;

    // ← After you deploy the relay, paste its URL here (or I'll set it for you):
    var RELAY_URL = "https://xiiownafkqllwjqrsdwp.supabase.co/functions/v1/christopher-chat";
    var ADMIN_URL = "https://xiiownafkqllwjqrsdwp.supabase.co/functions/v1/christopher-admin";
    var AV = "https://cdn.shopify.com/s/files/1/0611/9456/7795/files/thrivecycling-logo_1770548856942.png?v=1785393847";

    // ---- visitor context (funnel awareness) ----
    var VISIT = {};
    try {
      if (!sessionStorage.getItem("tcw_landing")) {           // capture landing angle/utm once per session
        var lp = new URLSearchParams(location.search);
        sessionStorage.setItem("tcw_landing", JSON.stringify({
          utm_source: lp.get("utm_source"), utm_medium: lp.get("utm_medium"), utm_campaign: lp.get("utm_campaign"),
          utm_content: lp.get("utm_content"), angle: lp.get("angle") || lp.get("utm_term") || lp.get("utm_content"),
          landing_path: location.pathname, referrer: document.referrer || null
        }));
      }
      var prevV = JSON.parse(localStorage.getItem("tcw_visits") || "null");   // returning / visits / recency
      var nowMs = (new Date()).getTime();
      VISIT.returning = !!prevV; VISIT.visits = (prevV ? prevV.visits : 0) + 1;
      if (prevV && prevV.last) VISIT.days_since_last = Math.floor((nowMs - prevV.last) / 86400000);
      localStorage.setItem("tcw_visits", JSON.stringify({ first: (prevV && prevV.first) || nowMs, visits: VISIT.visits, last: nowMs }));
    } catch (e) {}
    var VID = null;
    // contact-token bridge (2026-09-07): links Christopher/Marcus send in DMs/emails carry ?ct=<id>; Klaviyo links carry _kx.
  // Stored once, sent with every chat context so the relay binds THIS browser to that known person.
  try { var _u = new URLSearchParams(location.search); var _ct = _u.get("ct"); if (_ct && /^[0-9a-f-]{36}$/i.test(_ct)) localStorage.setItem("tcw_ct", _ct); var _kx = _u.get("_kx"); if (_kx && _kx.length > 8) localStorage.setItem("tcw_kx", _kx); } catch (e) {}
  try { VID = localStorage.getItem("tcw_vid"); if (!VID) { VID = "v_" + Math.random().toString(36).slice(2,10) + (new Date()).getTime().toString(36); localStorage.setItem("tcw_vid", VID); } } catch (e) {}
    // Device (for the Channel filter + conversation card) — cheap UA check.
    var DEVICE = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ? "Mobile Web" : "Desktop Web";
    // Coarse geo (for the conversation card's location) — fetched once per session, cached, never blocks.
    async function getGeo(){
      try {
        var c = sessionStorage.getItem("tcw_geo"); if (c) return JSON.parse(c);
        var g = await (await fetch("https://ipapi.co/json/")).json();
        var geo = { city: g.city || null, region: g.region || null, country: g.country_name || g.country || null };
        sessionStorage.setItem("tcw_geo", JSON.stringify(geo)); return geo;
      } catch (e) { return null; }
    }
    async function buildContext(){
      var ctx = { visitor_id: VID, current_page: location.pathname, returning: VISIT.returning, visits: VISIT.visits, device: DEVICE };
    try { var _c = localStorage.getItem("tcw_ct"); if (_c) ctx.contact_token = _c; var _k = localStorage.getItem("tcw_kx"); if (_k) ctx.kx = _k; } catch (e) {}
      if (VISIT.days_since_last != null) ctx.days_since_last = VISIT.days_since_last;
      try { ctx.landing = JSON.parse(sessionStorage.getItem("tcw_landing") || "{}"); } catch (e) {}
      try { var g = await getGeo(); if (g) ctx.geo = g; } catch (e) {}
      try { var cart = await (await fetch("/cart.js")).json(); ctx.cart_items = cart.item_count; ctx.cart_total = cart.total_price; if (Array.isArray(cart.items)) ctx.cart_lines = cart.items.slice(0, 5).map(function (i) { return i.quantity + "x " + i.product_title; }); } catch (e) {}
      try { if (window.__tcwCustomer) ctx.customer_email = String(window.__tcwCustomer); } catch (e) {}
      if (window.__tcwSkill) ctx.proactive_skill = window.__tcwSkill;   // which sales skill engaged them (per-skill measurement)
      return ctx;
    }

    // --- Kill switch (2026-07-03): ask the console backend if Christopher is enabled BEFORE
    // mounting any DOM. Fails OPEN on a network error (a bootstrap hiccup must never hide chat for
    // every visitor) — but an explicit enabled:false means don't mount the bubble at all. The same
    // fetch response also carries greeting/proactive/skills, so mountWidget() reuses it below
    // instead of a second round-trip. ---
    fetch(ADMIN_URL, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ action: "public" }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.enabled === false) return; mountWidget(c || {}); })
      .catch(function () { mountWidget({}); });

    function mountWidget(bootCfg){
    try {
    // --- icons (inline svg) ---
    var IC = {
      bubble: '<svg viewBox="0 0 24 24"><path d="M12 3C6.5 3 2 6.8 2 11.5c0 2.4 1.2 4.6 3.1 6.1L4 21l3.8-1.4c1.3.4 2.7.6 4.2.6 5.5 0 10-3.8 10-8.7S17.5 3 12 3z"/></svg>',
      send: '<svg viewBox="0 0 24 24"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>',
      menu: '<svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="2" rx="1"/><rect x="3" y="11" width="18" height="2" rx="1"/><rect x="3" y="16" width="18" height="2" rx="1"/></svg>',
      expand: '<svg viewBox="0 0 24 24"><path d="M4 4h6v2H6v4H4V4zm10 0h6v6h-2V6h-4V4zM4 14h2v4h4v2H4v-6zm14 0h2v6h-6v-2h4v-4z"/></svg>',
      edit: '<svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>',
      star: '<svg viewBox="0 0 24 24"><path d="M12 2l3 7h7l-5.5 4.5L18 22l-6-4-6 4 1.5-8.5L2 9h7z"/></svg>',
      tag: '<svg viewBox="0 0 24 24"><path d="M21.41 11.58l-9-9A2 2 0 0011 2H4a2 2 0 00-2 2v7a2 2 0 00.59 1.42l9 9a2 2 0 002.82 0l7-7a2 2 0 000-2.84zM6.5 8A1.5 1.5 0 118 6.5 1.5 1.5 0 016.5 8z"/></svg>',
      truck: '<svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3a1 1 0 00-1 1v11h2a3 3 0 006 0h4a3 3 0 006 0h2v-5l-2-3zm-.5 1.5L21 12h-4V9.5h2.5zM6 17.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm10 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"/></svg>',
      cart: '<svg viewBox="0 0 24 24"><path d="M7 18a2 2 0 102 2 2 2 0 00-2-2zM1 2v2h2l3.6 7.59-1.35 2.44A2 2 0 007 17h12v-2H7.42a.25.25 0 01-.22-.37L8.1 13h7.45a2 2 0 001.8-1.11L21 4H5.21l-.94-2zm16 16a2 2 0 102 2 2 2 0 00-2-2z"/></svg>',
      card: '<svg viewBox="0 0 24 24"><path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4v-6h16zm0-10H4V6h16z"/></svg>'
    };

    var css = `
    .tcw, .tcw *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}
    .tcw-fab{position:fixed;right:20px;bottom:90px;width:58px;height:58px;border-radius:29px;background:#2e8fff;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:999998;box-shadow:0 6px 20px rgba(46,143,255,.4)}
    .tcw-fab::before{content:"";position:absolute;top:-4px;left:-4px;width:calc(100% + 8px);height:calc(100% + 8px);border-radius:50%;background:#2e8fff;z-index:-1;opacity:.2;animation:tcwPulse 2s ease-out infinite}
    @keyframes tcwPulse{0%{transform:scale(.95);opacity:.25}70%{transform:scale(1.18);opacity:0}100%{opacity:0}}
    .tcw-fab svg{width:28px;height:28px;fill:#fff}
    /* attract-tap "thinking" dots on the closed bubble (bursts; green pops on the blue) */
    .tcw-fab .tcw-glyph{display:flex;align-items:center;justify-content:center;transition:opacity .22s}
    .tcw-think{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;gap:4px;opacity:0;transition:opacity .22s;pointer-events:none}
    .tcw-think i{width:6px;height:6px;border-radius:50%;background:#6EF3A5;display:block}
    .tcw-fab.thinking .tcw-glyph{opacity:0}
    .tcw-fab.thinking .tcw-think{opacity:1}
    .tcw-fab.thinking .tcw-think i{animation:tcwDot 1s infinite ease-in-out}
    .tcw-think i:nth-child(2){animation-delay:.15s}
    .tcw-think i:nth-child(3){animation-delay:.3s}
    @keyframes tcwDot{0%,80%,100%{transform:translateY(0);opacity:.5}40%{transform:translateY(-5px);opacity:1}}
    @media (prefers-reduced-motion: reduce){.tcw-fab.thinking .tcw-glyph{opacity:1}.tcw-fab.thinking .tcw-think{opacity:0}.tcw-fab.thinking .tcw-think i{animation:none}}
    /* icon nudge (Leo 2026-08-04, replaces the auto-opening pop-out): green badge dot + one short
       double-bounce at the moment the pop-out used to fire. Attention without covering the page. */
    .tcw-fab .tcw-badge{position:absolute;top:-2px;right:-2px;width:12px;height:12px;border-radius:50%;background:#6EF3A5;box-shadow:0 0 0 2px #fff;opacity:0;transform:scale(0);transition:opacity .25s,transform .25s;pointer-events:none}
    .tcw-fab.nudged .tcw-badge{opacity:1;transform:scale(1)}
    .tcw-fab.bounce{animation:tcwBounce .9s cubic-bezier(.36,.07,.19,.97)}
    @keyframes tcwBounce{0%,100%{transform:none}20%{transform:translateY(-10px)}40%{transform:translateY(0)}55%{transform:translateY(-5px)}70%{transform:translateY(0)}}
    @media (prefers-reduced-motion: reduce){.tcw-fab.bounce{animation:none}}
    .tcw-pro{position:fixed;right:20px;bottom:158px;width:auto;max-width:240px;z-index:999997;display:flex;flex-direction:column;gap:8px;animation:tcwIn .32s cubic-bezier(.4,0,.2,1) both}
    @keyframes tcwIn{from{opacity:0;transform:scale(.92) translateY(8px)}to{opacity:1;transform:none}}
    .tcw-pro__x{position:absolute;top:-9px;right:-9px;width:24px;height:24px;border-radius:50%;background:#fff;border:0;box-shadow:0 2px 8px rgba(0,0,0,.18);cursor:pointer;color:#888;font-size:15px;z-index:2}
    .tcw-pro__msg{background:#F0F1FE;border-radius:12px;padding:10px 14px;font-size:14px;line-height:1.4;color:#000;box-shadow:0 6px 22px rgba(10,14,30,.16);cursor:pointer;white-space:nowrap}
    .tcw-chips{display:flex;gap:8px;flex-wrap:wrap}
    .tcw-pill{display:inline-flex;align-items:center;gap:6px;min-height:38px;border:1px solid #2e8fff;background:#fff;border-radius:100px;color:#2e8fff;padding:8px 16px;font-size:14px;font-weight:500;cursor:pointer}
    .tcw-pill:hover{background:#2e8fff;color:#fff}
    .tcw-panel{position:fixed;right:20px;bottom:20px;width:300px;height:80vh;max-height:calc(100vh - 40px);background:#fff;border-radius:24px;box-shadow:0 12px 50px rgba(10,16,40,.22);z-index:999999;display:none;flex-direction:column;overflow:hidden;animation:tcwIn .26s cubic-bezier(.4,0,.2,1) both}
    .tcw-panel.open{display:flex}
    .tcw-panel.exp{width:400px;height:92vh}
    @media (max-width:520px){.tcw-panel,.tcw-panel.exp{right:0;bottom:0;width:100%;height:100%;max-height:100%;border-radius:0}}
    .tcw-head{background:#2e8fff;color:#fff;padding:18px 14px 15px;display:flex;align-items:center;gap:10px;border-radius:16px 16px 0 0;position:relative;z-index:2}
    .tcw-head__av{width:40px;height:40px;border-radius:50%;flex:0 0 auto;object-fit:cover;background:#fff;box-shadow:0 0 0 2px rgba(255,255,255,.35)}
    .tcw-head__txt{flex:1 1 auto;min-width:0;line-height:1.25}
    .tcw-head__name{font-weight:700;font-size:17px}
    .tcw-head__sub{font-size:12px;opacity:.85;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .tcw-head__btns{display:flex;gap:6px;flex:0 0 auto}
    .tcw-head__btn{width:28px;height:28px;border-radius:50%;padding:0;border:0;cursor:pointer;background:rgba(255,255,255,.14);color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;line-height:1}
    .tcw-head__btn:hover{background:rgba(255,255,255,.26)}
    .tcw-head__btn svg{width:15px;height:15px;fill:#fff}
    .tcw-body{flex:1 1 auto;display:flex;flex-direction:column;min-height:0;background:#fff;border-radius:24px 24px 0 0;box-shadow:0 -10px 0 10px #2e8fff;margin-top:-10px;position:relative;overflow:hidden}
    .tcw-msgs{flex:1 1 auto;overflow-y:auto;padding:22px 16px 8px;display:flex;flex-direction:column;gap:10px;background:#fff;border-radius:24px 24px 0 0}
    .tcw-row{display:flex;gap:8px;align-items:flex-end;max-width:100%}
    .tcw-row.user{justify-content:flex-end}
    .tcw-mini{width:28px;height:28px;border-radius:50%;flex:0 0 auto;object-fit:cover;background:#eee}
    .tcw-a{display:inline-block;border-radius:12px;padding:12px;max-width:270px;background:#F0F1FE;color:#000;font-size:16px;line-height:1.4;word-break:break-word;white-space:pre-wrap}
    .tcw-u{display:inline-block;border-radius:12px;padding:8px 12px;max-width:80%;background:#2e8fff;color:#fff;font-size:16px;line-height:1.4;margin-left:auto;word-break:break-word}
    .tcw-quick{display:flex;gap:8px;flex-wrap:wrap;padding-top:2px}
    .tcw-inwrap{flex:0 0 auto;padding:10px 12px 12px;background:#fff}
    .tcw-inpill{display:flex;align-items:center;gap:12px;border-radius:100px;background:rgba(29,29,40,.04);border:1px solid rgba(29,29,40,.08);padding:9px 8px 9px 16px}
    .tcw-inpill input{flex:1;border:0;outline:0;background:transparent;font-size:16px;color:#212121}
    .tcw-inpill input::placeholder{color:#9aa0ad}
    .tcw-send{width:36px;height:36px;border-radius:40px;background:#2e8fff;border:0;cursor:pointer;flex:0 0 auto;display:flex;align-items:center;justify-content:center;padding:8px}
    .tcw-send svg{width:18px;height:18px;fill:#fff}
    .tcw-foot{text-align:center;font-size:10px;color:#c2c7d2;padding:8px 0 0;letter-spacing:.3px}
    /* --- slide-out menu --- */
    .tcw-backdrop{position:absolute;inset:0;background:rgba(10,16,40,.28);z-index:6;opacity:0;pointer-events:none;transition:opacity .26s}
    .tcw-backdrop.open{opacity:1;pointer-events:auto}
    .tcw-menu{position:absolute;top:0;left:0;bottom:0;width:80%;max-width:320px;background:#fff;z-index:7;display:flex;flex-direction:column;padding:18px 16px;transform:translateX(-103%);transition:transform .28s cubic-bezier(.4,0,.2,1);box-shadow:10px 0 30px rgba(10,16,40,.18);overflow-y:auto}
    .tcw-menu.open{transform:none}
    .tcw-newconv{display:flex;align-items:center;justify-content:center;gap:10px;padding:12px 16px;background:#2e8fff;color:#fff;border:0;border-radius:44px;font-size:14px;font-weight:600;cursor:pointer;margin-bottom:20px;min-height:42px}
    .tcw-newconv svg{width:15px;height:15px;fill:#fff}
    .tcw-mitem{display:flex;align-items:center;gap:13px;width:100%;padding:11px 8px;border:0;background:transparent;cursor:pointer;font-size:14px;color:#222;text-align:left;border-radius:10px}
    .tcw-mitem:hover{background:#f3f4f8}
    .tcw-mitem svg{width:19px;height:19px;fill:#5b6270;flex:0 0 auto}
    .tcw-mlabel{font-size:11px;font-weight:600;color:#9aa0ad;text-transform:uppercase;letter-spacing:.5px;margin:18px 0 4px;padding:0 8px}
    .tcw-mrecent{font-size:13px;color:#9aa0ad;padding:6px 8px}
    .tcw-mbottom{margin-top:auto;border-top:1px solid #eef0f5;padding-top:6px}
    `;
    var s = document.createElement("style"); s.textContent = css; document.head.appendChild(s);

    var root = document.createElement("div"); root.className = "tcw";
    root.innerHTML =
      '<div class="tcw-pro" id="tcwPro" style="display:none">' +
        '<button class="tcw-pro__x" id="tcwProX">&times;</button>' +
        '<div class="tcw-pro__msg">Questions? I&rsquo;m here.</div>' +
      '</div>' +
      '<div class="tcw-fab" id="tcwFab"><span class="tcw-glyph">' + IC.bubble + '</span><span class="tcw-think"><i></i><i></i><i></i></span><span class="tcw-badge"></span></div>' +
      '<div class="tcw-panel" id="tcwPanel">' +
        '<div class="tcw-head">' +
          '<img class="tcw-head__av" src="' + AV + '" alt="">' +
          '<div class="tcw-head__txt"><div class="tcw-head__name">Christopher</div><div class="tcw-head__sub">Here to help with anything you need!</div></div>' +
          '<div class="tcw-head__btns">' +
            '<button class="tcw-head__btn" id="tcwMenuBtn" title="Menu">' + IC.menu + '</button>' +
            '<button class="tcw-head__btn" id="tcwExpand" title="Expand">' + IC.expand + '</button>' +
            '<button class="tcw-head__btn" id="tcwClose" title="Close">&times;</button>' +
          '</div>' +
        '</div>' +
        '<div class="tcw-body">' +
          '<div class="tcw-msgs" id="tcwMsgs">' +
            '<div class="tcw-row"><img class="tcw-mini" src="' + AV + '"><div class="tcw-a">G\'day &mdash; I\'m Christopher. Thinking about the HELIOS Pro Pack? Sizing, shipping, accuracy &mdash; ask me anything, I\'ll give it to you straight.</div></div>' +
            '<div class="tcw-quick"><button class="tcw-pill" data-q="What\'s included in the Pro Pack?">What\'s included?</button><button class="tcw-pill" data-q="What offers are available?">Offers</button></div>' +
          '</div>' +
          '<div class="tcw-inwrap"><div class="tcw-inpill"><input id="tcwInput" placeholder="Type anything here…"><button class="tcw-send" id="tcwSend">' + IC.send + '</button></div><div class="tcw-foot">Powered by THRIVE AI</div></div>' +
          '<div class="tcw-backdrop" id="tcwBackdrop"></div>' +
          '<div class="tcw-menu" id="tcwMenu">' +
            '<button class="tcw-newconv" id="tcwNew">' + IC.edit + ' New Conversation</button>' +
            '<button class="tcw-mitem" data-q="What do you recommend?">' + IC.star + ' What do you recommend?</button>' +
            '<button class="tcw-mitem" data-q="What offers are available right now?">' + IC.tag + ' Offers</button>' +
            '<button class="tcw-mitem" data-q="I\'d like to track my order">' + IC.truck + ' Track order</button>' +
            '<div class="tcw-mlabel">Recent Conversations</div>' +
            '<div class="tcw-mrecent" id="tcwRecent">Your recent chats will appear here.</div>' +
            '<div class="tcw-mbottom">' +
              '<button class="tcw-mitem" data-href="/cart">' + IC.cart + ' View cart</button>' +
              '<button class="tcw-mitem" data-href="/checkout">' + IC.card + ' Checkout</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    var panel = root.querySelector("#tcwPanel"), pro = root.querySelector("#tcwPro"), msgs = root.querySelector("#tcwMsgs"),
        input = root.querySelector("#tcwInput"), menu = root.querySelector("#tcwMenu"), backdrop = root.querySelector("#tcwBackdrop"),
        fabEl = root.querySelector("#tcwFab");
    var history = [], dismissed = false, openedVia = null;
    function genId(){ return "c-" + Math.random().toString(36).slice(2,10) + Date.now().toString(36); }
    var convId = genId();
    var SEED = msgs.innerHTML;

    // --- Popup anchoring (Leo 2026-07-03 fix): the proactive pop-out must ALWAYS sit directly above
    // the bubble — its bottom = bubble's top + 10px, right-aligned with the bubble — on EVERY viewport.
    // Root cause of the old detach bug: the popup relied on hardcoded CSS constants (bottom:158px) that
    // only match the bubble's DEFAULT spot, and the only re-anchor path (positionSurfaces) early-returned
    // on mobile (<=520px). So any bubble move (drag, or an accidental touch-drag while scrolling past the
    // fixed bubble) left the popup pinned to 158px while the bubble moved away → floated detached.
    // anchorPro() measures the bubble's live rect and pins the popup to it, unconditionally, so bubble +
    // popup always move as one unit. Guarded to no-op while hidden or while the cart drawer is open. ---
    function anchorPro(){
      if (!pro || !fabEl || pro.style.display === "none") return;
      if (root.classList.contains("tcw--drawer-open")) return;   // popup is suppressed while drawer open
      var r = fabEl.getBoundingClientRect();
      if (!r.width) return;
      var leftSide = r.left < innerWidth / 2;
      pro.style.top = "auto";
      if (leftSide){ pro.style.right = "auto"; pro.style.left = Math.max(8, Math.round(r.left)) + "px"; }
      else { pro.style.left = "auto"; pro.style.right = Math.max(8, Math.round(innerWidth - r.right)) + "px"; }
      pro.style.bottom = Math.max(8, Math.round(innerHeight - r.top + 10)) + "px";
    }
    var _anchorRaf = 0;
    function anchorProSoon(){ if (_anchorRaf) return; _anchorRaf = requestAnimationFrame(function(){ _anchorRaf = 0; anchorPro(); }); }
    addEventListener("scroll", anchorProSoon, { passive: true });
    addEventListener("resize", anchorProSoon);
    addEventListener("orientationchange", anchorProSoon);

    function showPro(){ pro.style.display = "flex"; if (fabEl) fabEl.classList.remove("thinking"); anchorPro(); }

    // Icon nudge (Leo 2026-08-04): the big chips pop-out no longer fires on cold arrivals — it
    // collided with the full-screen email popup. At proactive time the bubble bounces once and keeps
    // a badge dot until the chat is opened; a compact few-word pop fires separately at 30% scroll
    // depth (see armProactive). Skipped while the cart drawer has the bubble shifted (the bounce
    // transform would fight the drawer's translateX).
    function attractNudge(){
      if (!fabEl || panel.classList.contains("open")) return;
      if (root.classList.contains("tcw--drawer-open")) return;
      fabEl.classList.add("nudged");
      if (!_reduceMotion){ fabEl.classList.add("bounce"); setTimeout(function(){ fabEl.classList.remove("bounce"); }, 1000); }
    }

    function openPanel(){ panel.classList.add("open"); pro.style.display = "none"; stopThinking(); if (fabEl) fabEl.classList.remove("nudged"); try { sessionStorage.setItem("tcw_open", "1"); } catch (e) {} }
    function closePanel(){ panel.classList.remove("open"); closeMenu(); try { sessionStorage.removeItem("tcw_open"); } catch (e) {} }
    function openMenu(){ menu.classList.add("open"); backdrop.classList.add("open"); }
    function closeMenu(){ menu.classList.remove("open"); backdrop.classList.remove("open"); }

    // --- Attract-tap "thinking" dots on the CLOSED bubble (Leo 2026-07-03): three small green dots do a
    // typing-indicator bounce in short bursts (~2.7s on, ~9.3s off) to re-catch the eye. Stops for the
    // whole session once the user opens the chat or dismisses the pop-out. Never runs while the panel is
    // open, the pop-out is showing, or the cart drawer is open, and is fully disabled under
    // prefers-reduced-motion. The bubble itself never grows or pulses. ---
    var thinkStop = false;
    try { if (sessionStorage.getItem("tcw_think_off") === "1") thinkStop = true; } catch (e) {}
    var _reduceMotion = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
    function canThink(){
      if (thinkStop || _reduceMotion) return false;
      if (panel.classList.contains("open")) return false;
      if (pro && pro.style.display !== "none") return false;
      if (root.classList.contains("tcw--drawer-open")) return false;
      return true;
    }
    function stopThinking(){ thinkStop = true; if (fabEl) fabEl.classList.remove("thinking"); try { sessionStorage.setItem("tcw_think_off", "1"); } catch (e) {} }
    function thinkBurst(){ if (!fabEl) return; if (canThink()){ fabEl.classList.add("thinking"); setTimeout(function(){ fabEl.classList.remove("thinking"); }, 2700); } else { fabEl.classList.remove("thinking"); } }
    if (!_reduceMotion){ setTimeout(thinkBurst, 4000); setInterval(thinkBurst, 12000); }

    root.querySelector("#tcwFab").addEventListener("click", function(){ if (!openedVia) openedVia = (fabEl && fabEl.classList.contains("nudged")) ? "proactive" : "shopper"; panel.classList.contains("open") ? closePanel() : openPanel(); pro.style.display = "none"; });
    root.querySelector("#tcwClose").addEventListener("click", closePanel);
    root.querySelector("#tcwExpand").addEventListener("click", function(){ panel.classList.toggle("exp"); });
    root.querySelector("#tcwMenuBtn").addEventListener("click", function(){ menu.classList.contains("open") ? closeMenu() : openMenu(); });
    backdrop.addEventListener("click", closeMenu);
    root.querySelector("#tcwProX").addEventListener("click", function(e){ e.stopPropagation(); pro.style.display = "none"; dismissed = true; stopThinking(); });
    pro.addEventListener("click", function(e){ if (e.target.closest("#tcwProX")) return; if (!openedVia) openedVia = "proactive"; openPanel(); });
    root.querySelector("#tcwNew").addEventListener("click", function(){ history = []; msgs.innerHTML = SEED; closeMenu(); convId = genId(); openedVia = null; try { sessionStorage.removeItem("tcw_history"); sessionStorage.removeItem("tcw_convid"); } catch (e) {} });

    // --- Draggable bubble (Leo 2026-07-02): move Christopher anywhere on the page; position is
    // remembered per device. A real drag suppresses the click-to-open, and the pop-out + panel
    // re-anchor to whichever corner the bubble now lives in (desktop only — mobile stays full-screen). ---
    (function(){
      var fab = root.querySelector("#tcwFab"); if (!fab) return;
      fab.style.touchAction = "none";
      var PAD = 12, dragging = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0;
      function clamp(x, y){
        var w = fab.offsetWidth || 58, h = fab.offsetHeight || 58;
        return [ Math.max(PAD, Math.min(x, innerWidth - w - PAD)), Math.max(PAD, Math.min(y, innerHeight - h - PAD)) ];
      }
      function positionSurfaces(){
        anchorPro();                                   // pop-out tracks the bubble on EVERY viewport (mobile included)
        if (innerWidth <= 520) return;                 // mobile: panel stays full-screen (CSS media query)
        var r = fab.getBoundingClientRect();
        var leftSide = r.left < innerWidth / 2;
        panel.style.right = panel.style.left = panel.style.top = panel.style.bottom = "auto";
        if (leftSide) panel.style.left = r.left + "px"; else panel.style.right = (innerWidth - r.right) + "px";
        panel.style.bottom = Math.max(PAD, innerHeight - r.top + 10) + "px";
      }
      function place(x, y){
        var c = clamp(x, y);
        fab.style.left = c[0] + "px"; fab.style.top = c[1] + "px"; fab.style.right = "auto"; fab.style.bottom = "auto";
        positionSurfaces();
      }
      fab.addEventListener("pointerdown", function(e){
        dragging = true; moved = false; sx = e.clientX; sy = e.clientY;
        var r = fab.getBoundingClientRect(); ox = e.clientX - r.left; oy = e.clientY - r.top;
        try { fab.setPointerCapture(e.pointerId); } catch (_) {}
      });
      fab.addEventListener("pointermove", function(e){
        if (!dragging) return;
        if (!moved && Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy) > 5) moved = true;
        if (moved) place(e.clientX - ox, e.clientY - oy);
      });
      fab.addEventListener("pointerup", function(e){
        if (!dragging) return; dragging = false;
        try { fab.releasePointerCapture(e.pointerId); } catch (_) {}
        // Position is intentionally NOT persisted — a page refresh returns the bubble to its default spot.
      });
      // Kill the click that fires immediately after a drag so dragging never opens the chat.
      fab.addEventListener("click", function(e){ if (moved){ e.stopImmediatePropagation(); e.preventDefault(); moved = false; } }, true);
      // Do NOT restore a saved position — the bubble resets to its default spot on every refresh.
      // Clear any position saved by an earlier build so it can't linger.
      try { localStorage.removeItem("tcw_fab_pos"); } catch (_) {}
      addEventListener("resize", function(){ if (fab.style.left) place(parseInt(fab.style.left), parseInt(fab.style.top)); });
      var _open = openPanel; openPanel = function(){ _open(); if (fab.style.left) positionSurfaces(); };
    })();

    // --- Cart-drawer awareness (Leo 2026-07-03): while the Dawn cart drawer is open, the
    // proactive pop-out is suppressed entirely and the bubble + panel slide left of the drawer
    // panel so Christopher never covers drawer content (protection row / subtotal / payment
    // icons). Everything restores when the drawer closes. Positioning-only — no config change. ---
    (function(){
      var st2 = document.createElement("style");
      st2.textContent =
        ".tcw--drawer-open .tcw-pro{display:none !important}" +
        ".tcw .tcw-fab,.tcw .tcw-panel{transition:transform .28s cubic-bezier(.4,0,.2,1)}" +
        ".tcw--drawer-open .tcw-fab,.tcw--drawer-open .tcw-panel{transform:translateX(var(--tcw-shift,-420px))}";
      document.head.appendChild(st2);
      function hookDrawer(){
        var cd = document.querySelector("cart-drawer");
        if (!cd) return false;
        function apply(){
          var open = cd.classList.contains("active");
          if (open){
            var inner = cd.querySelector(".drawer__inner");
            var w = inner ? Math.ceil(inner.getBoundingClientRect().width) : 400;
            root.style.setProperty("--tcw-shift", "-" + (w + 14) + "px");
          }
          root.classList.toggle("tcw--drawer-open", open);
          // drawer closed → re-pin the pop-out, but AFTER the .28s slide-back finishes so we don't
          // measure the bubble mid-transition (which would left-anchor it to the shifted position).
          if (!open) setTimeout(anchorPro, 320);
        }
        new MutationObserver(apply).observe(cd, { attributes: true, attributeFilter: ["class"] });
        addEventListener("resize", function(){ if (cd.classList.contains("active")) apply(); });
        apply();
        return true;
      }
      if (!hookDrawer()) document.addEventListener("DOMContentLoaded", hookDrawer);
    })();

    function mdToHtml(s){
      s = s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
      s = s.replace(/\*\*([^*\n]+)\*\*/g,"<strong>$1</strong>");
      s = s.replace(/(^|\n)\s*[-*•]\s+/g,"$1• ");
      return s.replace(/\n/g,"<br>");
    }
    function addBubble(role, text){
      var row = document.createElement("div"); row.className = "tcw-row" + (role === "user" ? " user" : "");
      if (role !== "user"){ var a = document.createElement("img"); a.className = "tcw-mini"; a.src = AV; row.appendChild(a); }
      var b = document.createElement("div"); b.className = role === "user" ? "tcw-u" : "tcw-a"; b.textContent = text; row.appendChild(b);
      msgs.appendChild(row); msgs.scrollTop = msgs.scrollHeight; return b;
    }

    // Thread survives page navigation within the tab (found by Leo's mate mid-conversation,
    // 2026-07-06): history + conversation id + open state live in sessionStorage. The brain already
    // remembered server-side - this keeps the visible chat matching it.
    function saveThread(){
      try {
        sessionStorage.setItem("tcw_history", JSON.stringify(history.slice(-30)));
        sessionStorage.setItem("tcw_convid", convId);
      } catch (e) {}
    }
    function renderThread(){
      msgs.innerHTML = "";
      for (var i = 0; i < history.length; i++){
        var m = history[i];
        var b = addBubble(m.role === "user" ? "user" : "agent", "");
        if (m.role === "user") b.textContent = m.content; else b.innerHTML = mdToHtml(m.content);
      }
    }
    function restoreThread(){
      try {
        var saved = JSON.parse(sessionStorage.getItem("tcw_history") || "[]");
        if (saved.length){
          history = saved;
          var savedId = sessionStorage.getItem("tcw_convid"); if (savedId) convId = savedId;
          renderThread();
          if (sessionStorage.getItem("tcw_open") === "1"){ openPanel(); dismissed = true; }
          return;
        }
      } catch (e) {}
      // No thread in this tab - ask the brain for this visitor's last conversation so a returning
      // shopper SEES their history (new tab, next day, same device) instead of a stranger's greeting.
      try {
        if (!RELAY_URL) return;
        fetch(RELAY_URL, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ history_request: true, context: { visitor_id: VID } }) })
          .then(function(r){ return r.json(); })
          .then(function(d){
            if (!d || !d.messages || !d.messages.length) return;
            if (history.length) return; // they started typing meanwhile - never clobber
            history = d.messages.slice();
            renderThread();
            saveThread();
          })
          .catch(function(){ /* prefill is best-effort */ });
      } catch (e) {}
    }

    async function send(text){
      text = (text || input.value || "").trim(); if (!text) return;
      input.value = ""; addBubble("user", text); history.push({ role: "user", content: text }); saveThread();
      var bubble = addBubble("agent", "");
      if (!RELAY_URL){ bubble.textContent = "[Christopher is connected to the design — paste the relay URL to switch on Claude]"; return; }
      try{
        var ctx = await buildContext();
        ctx.conversation_id = convId; ctx.initiator = openedVia || "shopper";
        try { var c2 = await (await fetch("/cart.js")).json(); ctx.cart_items = c2.item_count; ctx.cart_total = c2.total_price; if (Array.isArray(c2.items)) ctx.cart_lines = c2.items.slice(0, 5).map(function (i) { return i.quantity + "x " + i.product_title; }); } catch (e) {}
        var res = await fetch(RELAY_URL, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ messages: history, context: ctx }) });
        var reader = res.body.getReader(), dec = new TextDecoder(), acc = "", buf = "";
        while (true){
          var r = await reader.read(); if (r.done) break;
          buf += dec.decode(r.value, { stream: true });
          var lines = buf.split("\n"); buf = lines.pop();
          for (var i = 0; i < lines.length; i++){
            var line = lines[i]; if (line.indexOf("data:") !== 0) continue;
            var data = line.slice(5).trim(); if (!data || data === "[DONE]") continue;
            try { var ev = JSON.parse(data); if (ev.type === "content_block_delta" && ev.delta && ev.delta.text){ acc += ev.delta.text; bubble.innerHTML = mdToHtml(acc); msgs.scrollTop = msgs.scrollHeight; } } catch (e) {}
          }
        }
        history.push({ role: "assistant", content: acc }); saveThread();
      } catch (e){ bubble.textContent = "Sorry — connection issue. Try again."; }
    }

    root.querySelector("#tcwSend").addEventListener("click", function(){ send(); });
    input.addEventListener("keydown", function(e){ if (e.key === "Enter"){ e.preventDefault(); send(); } });
    root.addEventListener("click", function(e){
      var href = e.target.closest("[data-href]"); if (href){ location.href = href.getAttribute("data-href"); return; }
      var q = e.target.closest("[data-q]"); if (q){ openPanel(); closeMenu(); send(q.getAttribute("data-q")); }
    });

    // Apply the bootstrap config (greeting + proactive) fetched by the kill-switch gate above —
    // no second round-trip — then arm the icon nudge + mini pop (Leo 2026-08-04: the old chips
    // pop-out is retired; its contextual line seeds the panel greeting so skill targeting still
    // lands on open). Timed nudge = badge + bounce only. The mini pop is ONE compact few-word
    // bubble gated on ~30% scroll depth — engaged readers get words, bouncers get nothing.
    function armProactive(ms, miniMsg){
      setTimeout(function(){ if (!dismissed && !panel.classList.contains("open")){ try { var st = window.__tcwProState || {}; if (st.hist) localStorage.setItem("tcw_pro_hist", JSON.stringify(st.hist)); if (st.sig) sessionStorage.setItem("tcw_pro_sess", st.sig); } catch (e) {} attractNudge(); if (!root.classList.contains("tcw--drawer-open")) showPro(); } }, ms);
      if (miniMsg){ var pm = root.querySelector(".tcw-pro__msg"); if (pm) pm.textContent = miniMsg; }
      var popped = false;
      function onDepth(){
        if (popped) return;
        var max = document.documentElement.scrollHeight - innerHeight;
        if (max < 300 || scrollY / max < 0.3) return;
        popped = true; removeEventListener("scroll", onDepth);
        if (!dismissed && !panel.classList.contains("open") && !root.classList.contains("tcw--drawer-open")) showPro();
      }
      addEventListener("scroll", onDepth, { passive: true });
    }
    (async function applyBootConfig(c){
        c = c || {};
        if (c.greeting){ var seed = root.querySelector(".tcw-a"); if (seed) seed.textContent = c.greeting; }
        var msg = c.proactive_message;   // stage-aware fallback: cart-stalled > returning > first-visit
        var want = "first";              // advertorial pages (/pages/*) get their own nudge + a shorter cooldown (Leo 2026-09-07)
        try {
          var cart = await (await fetch("/cart.js")).json();
          var itemCount = (cart && cart.item_count) || 0;
          if (Array.isArray(c.skills) && c.skills.length) {
            // The Sales Skills grid decides which proactive line fires, by context.
            want = itemCount > 0 ? "cart" : (/^\/products\/helios/.test(location.pathname) ? "ring" : /^\/products\/(farina|cliq)/.test(location.pathname) ? "lights" : location.pathname.indexOf("/products") === 0 ? "product" : (location.pathname.indexOf("/pages/") === 0 ? "advertorial" : (VISIT.returning ? "returning" : "first")));
            var enabledSkills = c.skills.filter(function (s) { return s && s.enabled; });
            var pick = enabledSkills.filter(function (s) { return s.trigger === want; })[0] || enabledSkills.filter(function (s) { return s.trigger === "first"; })[0] || enabledSkills[0];
            if (pick) { msg = pick.message; window.__tcwSkill = pick.id; }
          } else {
            if (itemCount > 0 && c.proactive_cart) msg = c.proactive_cart;
            else if (VISIT.returning && c.proactive_returning) msg = c.proactive_returning;
          }
        } catch (e) { if (VISIT.returning && c.proactive_returning) msg = c.proactive_returning; }
        // Proactive etiquette v2 (Leo 2026-07-07): a RETURNING visitor with the same cart gets a
        // FOLLOW-UP line, not the same pitch again - one pop per browser session, message varies
        // per return. Non-cart nudges keep a 24h cooldown so first-visit/returning lines don't nag.
        var isCartPitch = (typeof itemCount === "number" && itemCount > 0);
        var proSig = (isCartPitch ? "cart" : String(msg || "").slice(0, 40)) + "|" + (typeof itemCount === "number" ? itemCount : 0) + "|" + ((typeof cart === "object" && cart && cart.total_price) || 0);
        var hist = {}; try { hist = JSON.parse(localStorage.getItem("tcw_pro_hist") || "{}"); } catch (e) {}
        var sameAsLast = hist.sig === proSig;
        var seenThisSession = false; try { seenThisSession = sessionStorage.getItem("tcw_pro_sess") === proSig; } catch (e) {}
        if (seenThisSession) return; // already popped for this state in this session
        if (isCartPitch && sameAsLast) {
          // They came back and the cart hasn't moved - follow up, don't repeat.
          var FOLLOWUPS = [
            "Your cart's right where you left it. What's the holdup - price, timing, sizing? I'll give you a straight answer.",
            "Still weighing it up? Ask me the hard question - whatever's stalling you, I'd rather answer it than have you guessing.",
          ];
          msg = FOLLOWUPS[(hist.count || 0) % FOLLOWUPS.length];
          hist.count = (hist.count || 0) + 1;
        } else if (!isCartPitch && sameAsLast && Date.now() - (hist.at || 0) < (want === "advertorial" ? 4 * 3600000 : 86400000)) {
          return; // same non-cart nudge inside 24h - stay quiet
        } else {
          hist.count = 0; // new state (cart changed, or different pitch) - primary message, reset rotation
        }
        hist.sig = proSig; hist.at = Date.now();
        window.__tcwProState = { hist: hist, sig: proSig };
        // The contextual line greets INSIDE the panel — only when no restored thread would be clobbered.
        if (msg && !history.length){ var seed2 = root.querySelector(".tcw-a"); if (seed2){ seed2.textContent = msg; SEED = msgs.innerHTML; } }
        armProactive((Number(c.proactive_delay) || 6) * 1000, isCartPitch ? "Still weighing it up?" : (want === "advertorial" ? "Question about this? Ask me." : want === "ring" ? "Quick heads-up on stock." : want === "lights" ? "Quick heads-up on the set." : "Questions? I’m here."));
    })(bootCfg);

    restoreThread();

    // Live presence heartbeat — every 15s while the tab is visible
    function liteCtx(){ var c = { visitor_id: VID, current_page: location.pathname }; try { c.landing = JSON.parse(sessionStorage.getItem("tcw_landing") || "{}"); } catch (e) {} return c; }
    function heartbeat(){ if (document.hidden) return; try { if (localStorage.getItem("tcw_admin")) return; } catch (e) {} try { fetch(RELAY_URL, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ heartbeat: true, context: liteCtx() }) }); } catch (e) {} }
    heartbeat(); setInterval(heartbeat, 15000);
    } catch (e) { /* never break the page — mountWidget */ }
    } // end mountWidget
  } catch (e) { /* never break the page */ }
})();
